// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sectionThree {
  background: #1c2640;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 0 180px;
}
#sectionThree #sectionThree-content {
  display: flex;
  width: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 200px;
  margin-bottom: 100px;
  padding: 0px 95px;
}
#sectionThree #sectionThree-content #sectionThree-left {
  width: 55%;
}
#sectionThree #sectionThree-content #sectionThree-left .sub-title {
  width: 134px;
  height: 38px;
  gap: 0px;
  border-radius: 0px 7px 7px 7px;
  background: #fff;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 400;
  line-height: 15px;
  color: #435569;
  display: flex;
  align-items: center;
  justify-content: center;
}
#sectionThree #sectionThree-content #sectionThree-left .title {
  font-family: Roboto;
  font-size: 43px;
  font-weight: 400;
  line-height: 50.39px;
  text-align: left;
  color: #fff;
  margin-top: 30px;
}
#sectionThree #sectionThree-content #sectionThree-left .description {
  font-family: Roboto;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  color: #fff;
  margin-top: 30px;
  margin-bottom: 50px;
}
#sectionThree #sectionThree-content #sectionThree-left .btn-to-platform {
  width: 170.88px;
  height: 33px;
  gap: 0px;
  background: #EC6927;
  font-family: Roboto;
  font-size: 13.5px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
}
#sectionThree #sectionThree-content #sectionThree-right {
  width: 65%;
  text-align: right;
}
#sectionThree #sectionThree-content #sectionThree-head {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 43px;
  line-height: 50px;
  color: #ffffff;
  text-align: center;
}
#sectionThree #sectionThree-content #sectionThree-head-note {
  margin-bottom: 20px;
  font-size: 24px;
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
}
#sectionThree #sectionThree-content #sectionThree-subhead {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  color: #d8dee8;
  text-align: center;
  margin-bottom: 20px;
}
#sectionThree #sectionThree-content #sectionThree-card {
  padding: 50px;
  height: 480px;
  width: 100%;
  grid-gap: 5%;
  gap: 4%;
  background-color: white;
  border-radius: 10px;
  margin-top: 3%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
#sectionThree #sectionThree-content #sectionThree-card #sectionThree-card-top, #sectionThree #sectionThree-content #sectionThree-card #sectionThree-card-bottom {
  display: flex;
  width: 100%;
}
#sectionThree #sectionThree-content #sectionThree-card #sectionThree-card-bottom {
  border-top: 2px solid rgba(51, 51, 51, 0.5);
}
#sectionThree #sectionThree-content #sectionThree-card #sectionThree-card-1, #sectionThree #sectionThree-content #sectionThree-card #sectionThree-card-4 {
  padding: 30px;
  width: 33%;
  height: 165px;
  border-right: 2px solid rgba(51, 51, 51, 0.5);
}
#sectionThree #sectionThree-content #sectionThree-card #sectionThree-card-2, #sectionThree #sectionThree-content #sectionThree-card #sectionThree-card-5 {
  padding: 30px 40px;
  width: 36%;
  height: 165px;
  border-right: 2px solid rgba(51, 51, 51, 0.5);
}
#sectionThree #sectionThree-content #sectionThree-card #sectionThree-card-3, #sectionThree #sectionThree-content #sectionThree-card #sectionThree-card-6 {
  padding: 30px 40px;
  width: 30%;
  height: 165px;
}
#sectionThree #sectionThree-content #sectionThree-card #card-1-icon,
#sectionThree #sectionThree-content #sectionThree-card #card-2-icon,
#sectionThree #sectionThree-content #sectionThree-card #card-3-icon {
  width: 30px;
  height: 30px;
  margin-bottom: 15px;
}
#sectionThree #sectionThree-content #sectionThree-card #card-1-head1,
#sectionThree #sectionThree-content #sectionThree-card #card-2-head1,
#sectionThree #sectionThree-content #sectionThree-card #card-3-head1 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.6;
  font-variant: small-caps;
  color: #6a6a6a;
  margin-top: 4%;
}
#sectionThree #sectionThree-content #sectionThree-card #card-1-head2,
#sectionThree #sectionThree-content #sectionThree-card #card-2-head2,
#sectionThree #sectionThree-content #sectionThree-card #card-3-head2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 21px;
  line-height: 20px;
  text-transform: capitalize;
  color: #1c2640;
  margin-top: 2%;
}
#sectionThree #sectionThree-content #sectionThree-card #card-1-para,
#sectionThree #sectionThree-content #sectionThree-card #card-2-para,
#sectionThree #sectionThree-content #sectionThree-card #card-3-para {
  font-family: Roboto;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
}
#sectionThree #sectionThree-content #sectionThree-card-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: absolute;
  bottom: 35px;
  z-index: 1;
  text-align: center;
  margin: 40px auto;
}
#sectionThree #sectionThree-content #sectionThree-card-footer p {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #ec6927;
}
#sectionThree #sectionThree-content #sectionThree-card-footer button {
  text-align: center;
  padding: 10px;
  width: 150px;
  height: 40px;
  border: none;
  color: white;
  background: #ec6927;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  font-weight: bold;
  font-family: sans-serif;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  margin: 0 10px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  line-height: 20px;
  color: #ffffff;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/SectionThree/sectionThree.scss"],"names":[],"mappings":"AAEA;EACC,mBAHS;EAIT,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AADD;AAGC;EACC,aAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACG,iBAAA;EACA,oBAAA;EACA,iBAAA;AADL;AAGE;EACC,UAAA;AADH;AAEG;EACC,YAAA;EACG,YAAA;EACA,QAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACH,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACG,mBAAA;EACA,uBAAA;AAAP;AAEG;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAAJ;AAGG;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAIG;EACC,eAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAFJ;AAME;EACC,UAAA;EACA,iBAAA;AAJH;AAOE;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AALH;AAQE;EACI,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACH,kBAAA;EACA,gBAAA;AANH;AASE;EACC,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAPH;AAUE;EACC,aAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AARH;AAUG;EACC,aAAA;EACA,WAAA;AARJ;AAUG;EACC,2CAAA;AARJ;AAUG;EACC,aAAA;EACA,UAAA;EACA,aAAA;EACA,6CAAA;AARJ;AAUG;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,6CAAA;AARJ;AAUG;EACC,kBAAA;EACA,UAAA;EACA,aAAA;AARJ;AAWG;;;EAGC,WAAA;EACA,YAAA;EACA,mBAAA;AATJ;AAYG;;;EAGC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;AAVJ;AAaG;;;EAGC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,cAAA;AAXJ;AAcG;;;EAGC,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAZJ;AAgBE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAdH;AAgBG;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAdJ;AAiBG;EACC,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAfJ","sourcesContent":["$primary: #1c2640;\n\n#sectionThree {\n\tbackground: $primary;\n\twidth: 100%;\n\theight: auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 0 180px;\n\n\t#sectionThree-content {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t    margin-top: 200px;\n\t    margin-bottom: 100px;\n\t    padding: 0px 95px;\n\n\t\t#sectionThree-left{\n\t\t\twidth: 55%;\n\t\t\t.sub-title{\n\t\t\t\twidth: 134px;\n\t\t\t    height: 38px;\n\t\t\t    gap: 0px;\n\t\t\t    border-radius: 0px 7px 7px 7px;\n\t\t\t    background: #fff;\n\t\t\t    font-family: Roboto;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 15px;\n\t\t\t\tcolor: #435569;\n\t\t\t\tdisplay: flex;\n\t\t\t    align-items: center;\n\t\t\t    justify-content: center;\n\t\t\t}\n\t\t\t.title{\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-size: 43px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 50.39px;\n\t\t\t\ttext-align: left;\n\t\t\t\tcolor: #fff;\n\t\t\t\tmargin-top: 30px;\n\n\t\t\t}\n\t\t\t.description{\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 26px;\n\t\t\t\ttext-align: left;\n\t\t\t\tcolor: #fff;\n\t\t\t\tmargin-top: 30px;\n\t\t\t\tmargin-bottom: 50px;\n\t\t\t}\n\n\t\t\t.btn-to-platform{\n\t\t\t\twidth: 170.88px;\n\t\t\t\theight: 33px;\n\t\t\t\tgap: 0px;\n\t\t\t\tbackground: #EC6927;\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-size: 13.5px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 20px;\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: #fff;\n\t\t\t\tborder-radius: 3px;\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t\t#sectionThree-right{\n\t\t\twidth: 65%;\n\t\t\ttext-align: right;\n\t\t}\n\n\t\t#sectionThree-head {\n\t\t\tfont-family: Roboto;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 43px;\n\t\t\tline-height: 50px;\n\t\t\tcolor: #ffffff;\n\t\t\ttext-align: center;\n\t\t}\n\n\t\t#sectionThree-head-note {\n\t\t    margin-bottom: 20px;\n\t\t    font-size: 24px;\n\t\t    text-align: center;\n\t\t    font-family: Roboto;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t}\n\n\t\t#sectionThree-subhead {\n\t\t\tfont-family: Roboto;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: normal;\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 24px;\n\t\t\tcolor: #d8dee8;\n\t\t\ttext-align: center;\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\n\t\t#sectionThree-card {\n\t\t\tpadding: 50px;\n\t\t\theight: 480px;\n\t\t\twidth: 100%;\n\t\t\tgrid-gap: 5%;\n\t\t\tgap: 4%;\n\t\t\tbackground-color: white;\n\t\t\tborder-radius: 10px;\n\t\t\tmargin-top: 3%;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-start;\n\n\t\t\t#sectionThree-card-top, #sectionThree-card-bottom{\n\t\t\t\tdisplay: flex;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\t#sectionThree-card-bottom{\n\t\t\t\tborder-top: 2px solid rgba(51, 51, 51, 0.5);\n\t\t\t}\n\t\t\t#sectionThree-card-1, #sectionThree-card-4 {\n\t\t\t\tpadding: 30px;\n\t\t\t\twidth: 33%;\n\t\t\t\theight: 165px;\n\t\t\t\tborder-right: 2px solid rgba(51, 51, 51, 0.5);\n\t\t\t}\n\t\t\t#sectionThree-card-2, #sectionThree-card-5 {\n\t\t\t\tpadding: 30px 40px;\n\t\t\t\twidth: 36%;\n\t\t\t\theight: 165px;\n\t\t\t\tborder-right: 2px solid rgba(51, 51, 51, 0.5);\n\t\t\t}\n\t\t\t#sectionThree-card-3, #sectionThree-card-6 {\n\t\t\t\tpadding: 30px 40px;\n\t\t\t\twidth: 30%;\n\t\t\t\theight: 165px;\n\t\t\t}\n\n\t\t\t#card-1-icon,\n\t\t\t#card-2-icon,\n\t\t\t#card-3-icon {\n\t\t\t\twidth: 30px;\n\t\t\t\theight: 30px;\n\t\t\t\tmargin-bottom: 15px;\n\t\t\t}\n\n\t\t\t#card-1-head1,\n\t\t\t#card-2-head1,\n\t\t\t#card-3-head1 {\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 1.6;\n\t\t\t\tfont-variant: small-caps;\n\t\t\t\tcolor: #6a6a6a;\n\t\t\t\tmargin-top: 4%;\n\t\t\t}\n\n\t\t\t#card-1-head2,\n\t\t\t#card-2-head2,\n\t\t\t#card-3-head2 {\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 21px;\n\t\t\t\tline-height: 20px;\n\t\t\t\ttext-transform: capitalize;\n\t\t\t\tcolor: #1c2640;\n\t\t\t\tmargin-top: 2%;\n\t\t\t}\n\n\t\t\t#card-1-para,\n\t\t\t#card-2-para,\n\t\t\t#card-3-para {\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tline-height: 25px;\n\t\t\t}\n\t\t}\n\n\t\t#sectionThree-card-footer {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tposition: absolute;\n\t\t\tbottom: 35px;\n\t\t\tz-index: 1;\n\t\t\ttext-align: center;\n\t\t\tmargin: 40px auto;\n\n\t\t\tp {\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tline-height: 23px;\n\t\t\t\tcolor: #ec6927;\n\t\t\t}\n\n\t\t\tbutton {\n\t\t\t\ttext-align: center;\n\t\t\t\tpadding: 10px;\n\t\t\t\twidth: 150px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder: none;\n\t\t\t\tcolor: white;\n\t\t\t\tbackground: #ec6927;\n\t\t\t\tbox-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n\t\t\t\tborder-radius: 3px;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tfont-family: sans-serif;\n\t\t\t\tfont-size: 100%;\n\t\t\t\tline-height: 1.15;\n\t\t\t\tmargin: 0;\n\t\t\t\tmargin: 0 10px;\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: normal;\n\t\t\t\tfont-size: 13.5px;\n\t\t\t\tline-height: 20px;\n\t\t\t\tcolor: #ffffff;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
